import { Reducer } from 'redux'
import { getType } from 'typesafe-actions'
import { Config } from '@chegg-wt/core/config'
import { ActionTypes as CreateCitationActionTypes } from '../createCitation/constants'
import { FORM_LOADED } from '../form/constants'
import { logout } from '../user/actions'

import { ActionTypes } from './constants'
import { CurrentProjectState } from './types'

export const initialState: CurrentProjectState = {
  id: '',
  name: '',
  date: '',
  createdAt: '',
  defaultStyle: Config.currentStyle,
  generateNewCitationList: false,
  public: null,
  starred: null,
  citationCount: 0,
  isLoading: false,
  setInProgress: true,
  styleName: Config.currentStyleName,
  urlStyleName: '',
  __typename: 'Project',
}

export const currentProject: Reducer<CurrentProjectState> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case ActionTypes.SET_CURRENT_PROJECT_IN_PROGRESS:
      return {
        ...state,
        setInProgress: action.payload.status,
      }
    case ActionTypes.FETCH_CURRENT_PROJECT:
      return {
        ...state,
        isLoading: true,
      }
    case ActionTypes.SET_CURRENT_PROJECT:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
      }
    case ActionTypes.SET_STYLE_NAME:
    case ActionTypes.SET_URL_STYLE_NAME:
      return {
        ...state,
        ...action.payload,
      }
    case ActionTypes.FETCH_CURRENT_PROJECT_ERROR:
      return {
        ...state,
        isLoading: false,
      }
    case ActionTypes.STYLE_SELECTED:
    case CreateCitationActionTypes.CREATE_CITATION_SEARCH_RESULTS_PAGE_LOADED:
    case FORM_LOADED:
      return { ...state, defaultStyle: action.payload.style }
    case ActionTypes.GENERATE_NEW_CITATION_LIST:
      return {
        ...state,
        generateNewCitationList: action.payload.generateNewCitationList,
      }

    case getType(logout):
    case ActionTypes.CLEAR_CURRENT_PROJECT:
      return initialState
    default:
      return state
  }
}

export default currentProject
